import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorIcon } from "../../icons/ErrorIcon";
import { WarningIcon } from "../../icons/WarningIcon";
import { Message } from "./FieldStatus.styled";
const paletteMapping = {
    error: "expressiveNegative",
    warning: "expressiveWarning"
};
const iconMapping = {
    error: ErrorIcon,
    warning: WarningIcon
};
export const fieldStatusStringMap = {
    error: "Error",
    warning: "Warning"
};
export const FieldStatus = ({ level = "error", message, id, stringMap = fieldStatusStringMap, ...props }) => {
    const StatusIcon = iconMapping[level];
    return (_jsx("div", { "data-testid": "FieldStatusA11yWrapper", role: "status", "aria-live": "polite", ...props, children: message && (_jsxs(Message, { "data-testid": "FieldStatus", palette: paletteMapping[level], id: id, children: [_jsx(StatusIcon, { "aria-label": stringMap[level] }), " ", message] })) }));
};
